<template>

    <div>
        <div class="background"></div>
        <div v-on:click="close" class="close">
            <img src="../assets/close-white-18dp.svg">
        </div>
        <!-- Heading -->
        <div class="wrapper">
            <div class="heading">
                Edit Recipe
            </div>
        </div>
        <!-- Edit details -->
        <div class="wrapper">
            <!-- Title -->
            <div class="title">
                {{ this.title }}
            </div>
            <!-- Image -->
            <div class="image">
                <transition name="fade" appear>
                    <img v-if="image" :src="imgSrc">
                </transition>
            </div>
            <div class="edit-details">
                <div>
                    <form v-on:submit.prevent>
                        <div class="form-group">
                            <!-- Description -->
                            <div class="detail">
                                <label class="details-label" for="description">Short recipe description</label>
                                <label :class="countClass(description.length, 64)" class="details-count" for="description">{{description.length}} / 64</label>
                                <textarea
                                    @keydown.enter.exact.prevent
                                    @input="description = $event.target.value"
                                    :value="description"
                                    id="description"
                                    class="textarea description"
                                    maxlength="64"
                                ></textarea>
                            </div>
                            <!-- Story -->
                            <div class="detail">
                                <label class="details-label" for="story">Story behind the recipe</label>
                                <label :class="countClass(story.length, 1024)" class="details-count" for="story">{{story.length}} / 1024</label>
                                <textarea
                                    @input="story = $event.target.value"
                                    :value="story"
                                    id="story"
                                    class="textarea story"
                                    maxlength="1024"
                                ></textarea>
                            </div>
                            <!-- Component Names -->
                            <div class="detail">
                                <label class="details-label" for="componentNames">Components</label>
                                <div v-for="(component,index) in componentNames" v-bind:key="index">
                                    <textarea
                                        @keydown.enter.exact.prevent
                                        v-on:keydown.enter="listFocus($event,0)"
                                        @input="updateComponentNames(index, $event.target.value.charAt(0).toUpperCase() + $event.target.value.slice(1))"
                                        class="textarea textarea-list component-names"
                                        maxlength="32"
                                        :id="`component-names-${index}`"
                                    >
                                    </textarea>
                                </div>
                            </div>
                            <!-- Ingredients -->
                            <div v-if="componentNames[0]" class="detail">
                                <label class="details-label" for="ingredients">Ingredients</label>
                                <div class="ingredients" v-for="(component,componentIndex) in components" v-bind:key="componentIndex">
                                    <div class="ingredient-heading">
                                        {{ component['name'] }}
                                    </div>
                                    <div v-for="(ingredient,IngredientIndex) in component['ingredients']" v-bind:key="componentIndex-IngredientIndex">
                                        <textarea
                                            @keydown.enter.exact.prevent
                                            v-on:keydown.enter="listFocus($event,0)"
                                            @input="updateComponents(componentIndex, IngredientIndex, $event.target.value)"
                                            class="textarea textarea-list"
                                            :id="`components-${componentIndex}-${IngredientIndex}`"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <!-- Method -->
                            <div class="detail">
                                <label class="details-label" for="method">Method</label>
                                <div v-for="(instruction,index) in method" v-bind:key="index">
                                    <div class="method-count">{{ index + 1 }}</div>
                                    <textarea
                                        @keydown.enter.exact.prevent
                                        v-on:keydown.enter="listFocus($event,1)"
                                        @input="updateMethod(index, $event.target.value)"
                                        class="textarea textarea-list method"
                                        :id="`method-${index}`"
                                    >
                                    </textarea>
                                </div>
                            </div>
                            <!-- Tags -->
                            <div class="detail">
                                <label class="details-label" for="tags">Tags</label>
                                <label :class="countClass(tags.length, 32)" class="details-count" for="tags">{{tags.length}} / 32</label>
                                <textarea
                                    @keydown.enter.exact.prevent
                                    @input="tags = $event.target.value.toLowerCase()"
                                    :value="tags"
                                    class="textarea tags"
                                    maxlength="32"
                                ></textarea>
                            </div>
                            <!-- Serves -->
                            <div class="detail">
                                <label class="details-label" for="serves">Serves</label>
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 1) }">
                                        <input v-model="servings" value="1" type="radio" name="options" id="1" autocomplete="off"> 1
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 2) }">
                                        <input v-model="servings" value="2" type="radio" name="options" id="2" autocomplete="off"> 2
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 3) }">
                                        <input v-model="servings" v-bind:value="3" type="radio" name="options" id="option3" autocomplete="off"> 3
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 4) }">
                                        <input v-model="servings" v-bind:value="4" type="radio" name="options" id="option4" autocomplete="off"> 4
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 5) }">
                                        <input v-model="servings" v-bind:value="5" type="radio" name="options" id="option5" autocomplete="off"> 5
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 6) }">
                                        <input v-model="servings" v-bind:value="6" type="radio" name="options" id="option6" autocomplete="off"> 6
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 7) }">
                                        <input v-model="servings" v-bind:value="7" type="radio" name="options" id="option7" autocomplete="off"> 7
                                    </label>
                                    <label class="btn btn-outline-secondary" :class="{ active: (servings == 8) }">
                                        <input v-model="servings" v-bind:value="8" type="radio" name="options" id="option8" autocomplete="off"> 8
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="wrapper end">
                    <div v-on:click="update" class="next done" v-bind:class="[ done ? 'valid' : 'invalid']">
                        Update
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    name: 'Post',
    props: [
        'id'
    ],
    data () {
        return {
            title: '',
            description: '',
            story: '',
            componentNames: [''],
            components: [{
                name: '',
                ingredients: ['']
            }],
            method: [''],
            tags: '',
            servings: false,
            image: false,
            assets: ''
        }
    },
    created: function () {
        if (!this.authenticated) {
            this.login()
        }
        // Get recipe details
        axios.get('/api/recipes/' + this.id)
            .then(response => {
                if (response.data) {
                    this.title = response.data.recipe.title
                    this.description = response.data.recipe.description
                    this.story = response.data.recipe.story
                    if (response.data.recipe.components.length > 0) {
                        this.components = response.data.recipe.components
                    }
                    if (response.data.recipe.method.length > 0) {
                        this.method = response.data.recipe.method
                    }
                    this.tags = response.data.recipe.tags.join(' ')
                    this.servings = response.data.recipe.servings
                    this.assets = response.data.recipe.assets
                    this.image = response.data.recipe.image

                    // Get component names for components object
                    this.componentNames = this.components.map(c => {
                        return c.name
                    })

                    // Set text area heights
                    this.$nextTick(() => {
                        const descriptionEl = document.getElementById(`description`)
                        descriptionEl.style.height = descriptionEl.scrollHeight + 'px'
                        const storyEl = document.getElementById(`story`)
                        storyEl.style.height = storyEl.scrollHeight + 'px'
                    })

                    // Update text areas to match data
                    this.$nextTick(() => {
                        // Component Names
                        this.componentNames.forEach((component,index) => {
                            const el = document.getElementById(`component-names-${index}`)
                            if (this.componentNames[index]) {
                                el.value = this.componentNames[index]
                            }
                        })
                        // Ingredients
                        this.components.forEach((component,componentIndex) => {
                            this.components[componentIndex].ingredients.forEach((ingredient,IngredientIndex) => {
                                const el = document.getElementById(`components-${componentIndex}-${IngredientIndex}`)
                                if(this.components[componentIndex].ingredients[IngredientIndex]) {
                                    el.value = this.components[componentIndex].ingredients[IngredientIndex]
                                }
                            })
                        })
                        // Method
                        this.method.forEach((instruction,index) => {
                            const el = document.getElementById(`method-${index}`)
                            if (this.method[index]) {
                                el.value = this.method[index]
                            }
                        })
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })
    },
    methods: {
        close: function () {
            this.$router.push('/')
        },
        login: function () {
            window.location.replace("https://" + window.authEndpoint + "/login?response_type=code&client_id=" + window.cognitoAppClientId + "&redirect_uri=https://" + window.redirectUri)
        },
        log: function (e) {
            console.log(e)
        },
        listFocus: function (e,child){
            if(e.target.parentElement.nextElementSibling){
                e.target.parentElement.nextElementSibling.children[child].focus()
            }
        },
        updateMethod: function (index, value) {
            if (value || index < (this.method.length - 2) ) {
                this.method.splice(index, 1, value)
            } else {
                this.method.splice(index, 1)
            }
        },
        updateComponentNames: function (index, value) {
            if (value || index < (this.componentNames.length - 2) ) {
                this.componentNames.splice(index, 1, value)
            } else {
                this.componentNames.splice(index, 1)
                this.components.splice(index, 1)
            }
        },
        updateComponents: function (componentIndex, IngredientIndex, value) {
            if (value || IngredientIndex < (this.components[componentIndex].ingredients.length - 2) ) {
                this.components[componentIndex].ingredients.splice(IngredientIndex, 1, value)
                this.components = [].concat(this.components)
            } else {
                this.components[componentIndex].ingredients.splice(IngredientIndex, 1)
                this.components = [].concat(this.components)
            }
        },
        countClass: function (count, max) {
            if (count >= max) {
                return 'count-invalid'
            } else {
                return 'count-standard'
            }
        },
        update: function () {
            if ( this.done ) {
                let vm = this
                vm.withAuth(function () {
                    var headers = {}
                    var body = {
                        description: vm.description,
                        story: vm.story,
                        components: vm.components.map(c => {
                            return {
                                name: c.name,
                                ingredients: c.ingredients.slice(0, -1)
                            }
                        }),
                        method: vm.method.slice(0, -1),
                        tags: vm.tags,
                        servings: vm.servings
                    }
                    headers['Authorization'] = 'Bearer ' + vm.$store.getters.id_token
                    axios.put('/api/author/recipes/' + vm.id, body, { headers: headers })
                        .then(response => {
                            if (response.data) {
                                console.log(response.data)
                                vm.$router.replace('/')
                            }
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
            }
        }
    },
    computed: {
        ...mapGetters([
            'authenticated'
        ]),
        imgSrc () {
            return this.assets + this.id + '/' + this.id + '-960.jpeg'
        },
        done() {
            return (
                this.description && 
                this.story && 
                this.method.length > 1 && 
                this.components[0].name &&
                this.components[0].ingredients[0] && 
                this.servings
            )
        }
    },
    watch: {
        description: function () {
            const el = document.getElementById('description')
            // Remove line breaks from input
            if (el.value.match(/\n/g)) {
                el.value = el.value.replace(/(\r\n|\n|\r)/gm, "")
                this.description = el.value
            }
            // Auto resize input fields
            el.style.height = 0
            el.style.height = el.scrollHeight + 'px'
        },
        story: function () {
            const el = document.getElementById('story')
            // Auto resize input fields
            el.style.height = 0
            el.style.height = el.scrollHeight + 'px'
        },
        componentNames: function () {
            this.$nextTick(() => {
                this.componentNames.forEach((component,index) => {
                    const el = document.getElementById(`component-names-${index}`)
                    // Remove line breaks from input, and focus next field
                    if (el.value.match(/\n/g)) {
                        el.value = el.value.replace(/(\r\n|\n|\r)/gm, "")
                        this.method.splice(index, 1, el.value)
                        el.parentElement.nextElementSibling.children[0].focus()
                    }
                    // Auto resize input fields
                    el.style.height = 0
                    el.style.height = el.scrollHeight + 'px'
                })
            })
            // Add new input field if the last one has content
            if (this.componentNames[this.componentNames.length - 1]) {
                this.componentNames.push('')
            }
            // Add component for each component name
            this.componentNames.forEach((componentName,index) => {
                if (componentName) {
                    if (!this.components[index]) {
                        this.components[index] = {
                            name: componentName,
                            ingredients: ['']
                        }
                        this.nextComponentId++
                    } else {
                        this.components[index].name = componentName
                    }
                } else {
                    if (this.components[index]) {
                        this.components[index].name = componentName
                    }
                }
            })
        },
        method: function () {
            this.$nextTick(() => {
                this.method.forEach((instruction,index) => {
                    const el = document.getElementById(`method-${index}`)
                    // Remove line breaks from input, and focus next field
                    if (el.value.match(/\n/g)) {
                        el.value = el.value.replace(/(\r\n|\n|\r)/gm, "")
                        this.method.splice(index, 1, el.value)
                        el.parentElement.nextElementSibling.children[1].focus()
                    }
                    // Auto resize input fields
                    el.style.height = 0
                    el.style.height = el.scrollHeight + 'px'
                })
            })
            // Add new input field if the last one has content
            if (this.method[this.method.length - 1]) {
                this.method.push('')
            }
        },
        components: function () {
            this.components.forEach((component,componentIndex) => {
                this.$nextTick(() => {
                    this.components[componentIndex].ingredients.forEach((ingredient,IngredientIndex) => {
                        const el = document.getElementById(`components-${componentIndex}-${IngredientIndex}`)
                        // Remove line breaks from input, and focus next field
                        if (el && el.value.match(/\n/g)) {
                            el.value = el.value.replace(/(\r\n|\n|\r)/gm, "")
                            this.components[componentIndex].ingredients.splice(IngredientIndex, 1, el.value)
                            el.parentElement.nextElementSibling.children[0].focus()
                        }
                        // Auto resize input fields
                        if(el) {
                            el.style.height = 0
                            el.style.height = el.scrollHeight + 'px'
                        }
                    })
                })
                // Add new input field if the last one has content
                if (this.components[componentIndex].ingredients[this.components[componentIndex].ingredients.length - 1]) {
                    this.components[componentIndex].ingredients.push('')
                }
            })
        },
        tags: function () {
            if (this.tags.match(/\n/g)) {
                this.tags = this.tags.replace(/(\r\n|\n|\r)/gm, "")
            }
        }
    }
}
</script>

<style scoped>
    .background {
        background-image: url(../assets/bbg3.svg);
        position: absolute;
        height: 100%;
        width: 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .close {
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 22px;
    }
    .close img {
        width: 30px;
        height: 30px;
    }
    .wrapper {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .heading {
        margin: 20px;
        font-size: 1.4em;
        font-weight: 600;
        font-family: 'Comfortaa', Arial;
        color: #ffffff;
        z-index: 1000;
    }
    .title {
        top: 20vh;
        width: 90vw;
        position: absolute;
        font-size: 1.2em;
        font-weight: 600;
        font-family: 'Comfortaa', Arial;
        color: #00B4CC;
    }
    .label {
        position: absolute;
        padding-left: 10px;
        padding-top: 6px;
        z-index: 1000;
        font-size: 1em;
        font-family: 'Comfortaa', Arial;
        color: #5B7083;
    }
    .count {
        position: absolute;
        right: 0px;
        padding-right: 10px;
        padding-top: 6px;
        z-index: 1000;
        font-size: 1em;
        font-family: 'Comfortaa', Arial;
        color: #5B7083;
    }
    .details-label {
        position: relative;
        left: 0px;
        padding-top: 6px;
        font-size: 1em;
        font-family: 'Comfortaa', Arial;
        color: #5B7083;
    }
    .details-count {
        position: absolute;
        right: 0px;
        padding-top: 6px;
        font-size: 1em;
        font-family: 'Comfortaa', Arial;
        color: #5B7083;
    }
    .next {
        bottom: 20vh;
        position: absolute;
        color: #ffffff;
        font-size: 1.6em;
        font-weight: 900;
        letter-spacing: 0.2em;
        font-family: 'Comfortaa', Arial;
        padding: 10px 100px;
        max-width: 85vw;
    }
    .next:hover {
        cursor: pointer;
    }
    .done {
        bottom: unset;
    }
    .end {
        height: 120px;
    }
    .image {
        margin-top: 16vh;
        margin-bottom: 20px;
        display: flex;
        background-color: #ffffff;
        width: 100vw;
        height: 75vw;
    }
    .image img {
        width: 100vw;
        height: auto;
    }
    .count-standard {
        color: #5B7083;
    }
    .count-invalid {
        color: #E0245E;
    }
    .valid {
        background-color: #00B4CC;  
    }
    .invalid {
        background-color: #CED4DA;
        color: #5B7083;
    }
    .edit-details {
        position: flex;
        top: 17vh;
    }
    .form-group {
        margin-bottom: 10px;
    }
    .form-control {
        backdrop-filter: blur(16px);
        color: #000000;
        font-family: 'Comfortaa', Arial;
        font-size: 1.6em;
        text-align: center;
        padding-top: 60px;
        padding-bottom: 30px;
        outline: none;
        box-shadow: none;
        border-radius: 0;
    }
    .detail {
        padding-top: 10px;
        padding-bottom: 10px;
        position: relative;
    }
    .textarea {
        padding: 10px;
        display: block;
        width: 90vw;
        overflow: hidden;
        resize: vertical;
        min-height: 40px;
        line-height: 20px;
        border: solid;
        border-width: 1px;
        border-color: #CED4DA;
        font-size: 1em;
        font-family: 'Comfortaa', Arial;
        color: #000000;
    }
    .textarea-list {
        margin-bottom: 10px;
        height: 40px;
    }
    .btn-group, .btn {
        width: 100%;
    }
    .btn-outline-secondary {
        border-color: #CED4DA;
    }
    .btn.btn-outline-secondary:active:hover,
    .btn.btn-outline-secondary:hover,
    .btn-outline-secondary:not(:disabled):not(.disabled).active {
        background-color: #00B4CC;
    }
    .method-count {
        padding-top: 8px;
        padding-left: 10px;
        position: absolute;
        color: #00B4CC;
        font-weight: 400;
    }
    .method {
        padding-left: 25px;
    }
    .ingredients {
        padding-top: 15px;
    }
    .ingredient-heading {
        font-size: 1em;
        padding: 10px;
        margin-bottom: 10px;
        color: #ffffff;
        background-color: #00B4CC;
        height: 40px;
    }
    .tags {
        height: 40px;
    }
    .textarea:focus {
        border-color: #00B4CC;
        box-shadow: none;
        outline: none !important;
    }
    /* Transitions */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 500ms ease-in-out;
    }
    .fade-enter-to, .fade-leave {
        opacity: 1;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>